module.exports = __webpack_public_path__ + "static/media/Logo.470d8c61.png";